module.exports = __webpack_public_path__ + "static/media/Comfortaa.f40889ca.ttf";